import React, { memo, useCallback, useState, useEffect, useMemo } from 'react';
import { FormSelect, FormSelectItem, FormSelectProps } from './FormSelect';
import { isEmail } from '@core/utils/form/validation/validators/isEmail';
import { FormControl } from '@core/utils/form';
import { R } from '@core/utils/r';

export interface FormEmailSelectProps {
  emails: FormSelectItem<string>[];
  selectedEmails?: FormSelectItem<string>[];
  dontPrefill?: boolean;
}

export const FormEmailSelect = memo((props: FormEmailSelectProps & Omit<FormSelectProps<any>, 'items'>) => {
  const { emails, selectedEmails = undefined, dontPrefill = false, ...rest } = props;
  const uniqueEmails = useMemo(() => R.uniqBy(emails, 'value'), [emails]);
  const [values, setValues] = useState<FormSelectItem<string>[]>(uniqueEmails);

  useEffect(() => {
    if (!dontPrefill) {
      if (selectedEmails) {
        setValues([...selectedEmails, ...uniqueEmails]);
      } else {
        setValues(uniqueEmails);
      }
    } else {
      //   setValues(emails);
    }
  }, [dontPrefill, uniqueEmails, selectedEmails]);

  const onValueAdd = useCallback(
    (value, control: FormControl) => {
      if (isEmail(value)) {
        setValues([...values, { value, label: value }]);
        control.setValue(R.compact([...(control.value || []), value]));
      }
    },
    [values],
  );

  return (
    <FormSelect
      {...rest}
      items={values}
      onAdd={value => onValueAdd(value, props.control)}
      noOptionsMessage="Please provide email address and press enter."
    />
  );
});
